import type { DictionaryType } from 'types/story';
import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { getText } from 'utils/dictionary';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Fields/TextField/TextField';
import { FieldBBErrorType, FieldBBType } from '../constants';

type Props = {
	dictionary?: DictionaryType;
};

export const TEXT_FIELD = ({ dictionary = {} }: Props = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.TEXT_FIELD;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: TEXT_FIELD.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
						[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
					},

					componentProps: {
						[UNIFORM_PROPS.fieldType]: FieldBBType.text,
						[UNIFORM_PROPS.fieldPlaceholder]: getText(dictionary, type, 'placeholder.text'),
						// [UNIFORM_PROPS.fieldError]: {
						// 	// [FieldBBErrorType.required]: 'required',
						// 	// [FieldBBErrorType.email]: 'email is required',
						// 	// ...
						// },
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
								},
							},
						},
						other: {
							// 	[COMPONENT_STATES.DEFAULT]: {
							// 		[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
							// 			// ...
							// 		},
							// 	},
						},
					},
					nodeProps: {
						id: generateNodeId(_id, TEXT_FIELD.displayName),
					},
				},
				children: [],
			};
		},
	};
};

TEXT_FIELD.displayName = 'TextField';
